import React, { useEffect, useState } from "react";
import { Users, UserCog, Calendar, ClipboardCheck } from "lucide-react";
import api from "@/lib/api";
import { PeriodeProgress } from "./PeriodeProgress";

function Card({ icon: Icon, label, value, accent }) {
  return (
    <div className="bg-white border border-slate-200 rounded-sm p-5 hover:shadow-md transition-shadow">
      <div className={`w-10 h-10 rounded-sm flex items-center justify-center mb-3 ${accent}`}>
        <Icon className="w-5 h-5" />
      </div>
      <div className="text-3xl font-heading font-bold text-navy-900 font-mono">{value}</div>
      <div className="text-xs uppercase tracking-wide text-slate-500 mt-1">{label}</div>
    </div>
  );
}

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/dashboard").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div className="p-4 md:p-8">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-widest text-brass-600 font-semibold mb-1">Beranda</div>
        <h1 className="font-heading text-3xl font-bold text-navy-900">Dashboard Admin</h1>
        <p className="text-slate-500 mt-1 text-sm">Ringkasan statistik sistem penilaian.</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-testid="dashboard-stats">
        <Card icon={Users} label="Total Serdik" value={stats?.total_siswa ?? "—"} accent="bg-navy-100 text-navy-900" />
        <Card icon={UserCog} label="Pengasuh" value={stats?.total_pengasuh ?? "—"} accent="bg-brass-100 text-brass-700" />
        <Card icon={Calendar} label="Jadwal Aktif" value={stats?.periode_aktif ?? "—"} accent="bg-emerald-100 text-emerald-700" />
        <Card icon={ClipboardCheck} label="Pengisian Selesai" value={stats?.total_submissions ?? "—"} accent="bg-blue-100 text-blue-700" />
      </div>

      <PeriodeProgress items={stats?.periode_progress} />

      <div className="bg-white border border-slate-200 rounded-sm p-6">
        <h2 className="font-heading font-bold text-lg text-navy-900 mb-3">Alur Penggunaan</h2>
        <ol className="space-y-3 text-sm text-slate-700">
          <li className="flex gap-3">
            <span className="w-6 h-6 rounded-full bg-brass-500 text-navy-900 font-bold text-xs flex items-center justify-center flex-shrink-0">1</span>
            <span><strong>Daftarkan Serdik & Pengasuh</strong> melalui menu Serdik dan Pengasuh.</span>
          </li>
          <li className="flex gap-3">
            <span className="w-6 h-6 rounded-full bg-brass-500 text-navy-900 font-bold text-xs flex items-center justify-center flex-shrink-0">2</span>
            <span><strong>Buat Jadwal Pengisian</strong> dengan memilih kelompok Serdik, jenis (mingguan/bulanan), nomor periode, dan Pengasuh penanggung jawab.</span>
          </li>
          <li className="flex gap-3">
            <span className="w-6 h-6 rounded-full bg-brass-500 text-navy-900 font-bold text-xs flex items-center justify-center flex-shrink-0">3</span>
            <span><strong>Serdik mengisi Sosiometri</strong> (menilai 3 rekan dalam sistem rotating).</span>
          </li>
          <li className="flex gap-3">
            <span className="w-6 h-6 rounded-full bg-brass-500 text-navy-900 font-bold text-xs flex items-center justify-center flex-shrink-0">4</span>
            <span><strong>Pengasuh mengatur Ranking</strong> siswa di periode tersebut — sistem akan otomatis menghitung hasil observasi.</span>
          </li>
          <li className="flex gap-3">
            <span className="w-6 h-6 rounded-full bg-brass-500 text-navy-900 font-bold text-xs flex items-center justify-center flex-shrink-0">5</span>
            <span><strong>Lihat Hasil</strong> dan cetak dokumen Sosiometri & Catatan Siku Perorangan.</span>
          </li>
        </ol>
      </div>
    </div>
  );
}
